import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Global unhandled promise rejection handler - prevents app crashes
window.addEventListener('unhandledrejection', (event) => {
  console.error('[Global] Unhandled promise rejection:', event.reason);
  
  // Check if it's a retryable error - don't crash the app
  const message = event.reason?.message || String(event.reason);
  if (message.includes('RETRYABLE') || message.includes('busy') || message.includes('503') || message.includes('queue')) {
    console.log('[Global] Retryable/queue error caught - app will continue');
    event.preventDefault();
    return;
  }
});

// ✅ SIMPLIFIED: Removed invisible reCAPTCHA widget initialization
// RecaptchaGate handles visible verification when needed

createRoot(document.getElementById("root")!).render(<App />);
